import { configValues } from 'src/config';

export const articles = () => [
  {
    title: 'Top 10 reasons to buy a franchise',
    url: `${configValues.HEADER_SERVER_BASE}/business-resources/top-10-reasons-to-buy-a-franchise`,
    imageUrl: `${configValues.HEADER_SERVER_BASE}/wp-content/uploads/2016/07/Top_10_reasons_to_buy_a_franchise.jpg`,
    secondaryTitle: '4 min read',
  },
  {
    title: 'Buying a franchise vs independent business',
    url: `${configValues.HEADER_SERVER_BASE}/business-resources/franchise-or-independent`,
    imageUrl: `${configValues.HEADER_SERVER_BASE}/wp-content/uploads/2016/06/Buying_an_independent_business_vs_buying_a_franchise-V3.jpg`,
    secondaryTitle: '5 min read',
  },
  {
    title: '5 things a first-time franchisee needs to know',
    url: `${configValues.HEADER_SERVER_BASE}/business-resources/five-things-a-first-time-franchisee-needs-to-know`,
    imageUrl: `${configValues.HEADER_SERVER_BASE}/wp-content/uploads/2017/02/5-things-a-first-time-franchisee-needs-to-know-FINAL.jpg`,
    secondaryTitle: '3 min read',
  },
];
